export default __webpack_public_path__ + "static/media/new-bg.804656dc.png";